import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconLogoutComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={1.5}>
      <path
        d="M15.8 9V5.2A2.3 2.3 0 0 0 13.4 3h-6a2.3 2.3 0 0 0-2.3 2.3v13.4A2.3 2.3 0 0 0 7.5 21h6a2.3 2.3 0 0 0 2.3-2.3V15M12 9l-3 3m0 0 3 3m-3-3h12.8"
        fill="none"
        stroke="currentColor"
      />
    </SvgIcon>
  );
};

IconLogoutComponent.displayName = 'IconLogout';

const IconLogout = memo(IconLogoutComponent);

export default IconLogout;
